if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.productIdInput = this.form.querySelector('[name=id]');
            this.productIdInput.disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            if(this.productIdInput.value == ''){
                this.variantError();
                return
            }
            if(this.querySelector('.error-message')){
                this.querySelector('.error-message').remove();
            }
            this.removeErrorsBlock();
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.add('loading');
				})
			}
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.succses()
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
			console.log(resp)
            console.log(resp.description);
			let productInfo = this.closest('.product-info-container').querySelector('.product-info-quantity-selector')
			if(productInfo){
				let errorBlock = document.createElement('div');
				errorBlock.classList.add('product-error');
				errorBlock.classList.add('product-info-quantity-selector');
				errorBlock.innerHTML = resp.description
				console.log(errorBlock)
				if(this.closest('.product-info-container').querySelector('.product-error')){
					this.closest('.product-info-container').querySelector('.product-error').innerHTML = resp.description
				}else{
					productInfo.after(errorBlock);
				}
			}
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
				})
			}
			if(resp.status == 422){
				this.succses();
			}
        }

        succses() {
            console.log("Success");
			if(this.querySelectorAll('button[name="add"]')){
				this.querySelectorAll('button[name="add"]').forEach(function (button){
					button.classList.remove('loading');
				})
			}


			updateCartPopup();
			updateCartCount();
			if (document.querySelector('#cart-popup')) {
				document.querySelector('#cart-popup').classList.add('open');
				document.body.classList.add('disable-scroll');
			}
			if (document.querySelector('.cart-popup-overflow')) {
				document.querySelector('.cart-popup-overflow').classList.add('open');
			}
        }
        variantError(){
			const element = document.getElementById('size-select');
			if (element) {
				const offset = document.querySelector('header').offsetHeight + 50;
				const elementRect = element.getBoundingClientRect().top;
				const bodyRect = document.body.getBoundingClientRect().top;
				const offsetPosition = elementRect - bodyRect - offset;
				if (window.innerWidth <= 767) {
					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}
        }
        removeErrorsBlock(){

        }

        errorPopup(text){
			console.log(text)
        }

    });
}
